// Real DSHB collection names — matches backend/generator.js's
// externalIdMap exactly (case/spacing must match for the commerce
// category export to look these up correctly).
//
// Antibody-type and host+clonality combos (e.g. "Mouse Monoclonal
// Antibodies", "Recombinant Antibodies") are also auto-generated during
// CSV export from each item's own Host Species + Clonality fields (see
// generator.js's buildCommerceCategoryRows). They're included below too,
// by request, as manual picks on top of that — generator.js dedupes
// against the auto-derived rows so picking one here never produces a
// duplicate category entry for the same item.
//
// Shared by DepositorForm.js (depositor's own Collections picker) and
// ProductDetails.js (Admin's CollectionsField) — one list instead of two
// copies that can drift apart (which is exactly what happened before:
// Admin's own copy was a stale placeholder missing 11 valid collections
// and wrongly including "Recombinant Antibodies" plus two collections
// that don't even exist in externalIdMap at all).
export const COLLECTIONS_OPTIONS = [
  "Monoclonal Antibodies", "Polyclonal Antibodies", "Recombinant Antibodies",
  "Mouse Monoclonal Antibodies", "Rat Monoclonal Antibodies",
  "Rabbit Monoclonal Antibodies", "Hamster Monoclonal Antibodies",
  "Guinea Pig Monoclonal Antibodies", "Mouse Polyclonal Antibodies",
  "Rat Polyclonal Antibodies", "Rabbit Polyclonal Antibodies",
  "Hamster Polyclonal Antibodies", "Goat Polyclonal Antibodies",
  "Guinea Pig Polyclonal Antibodies", "Mouse Recombinant Antibodies",
  "Rabbit Recombinant Antibodies",
  "C. elegans", "CD antigens", "Cancer targets - NCI", "Cardiac development",
  "Cell adhesion", "Cell markers", "Cell signaling", "Cytoskeleton",
  "Dictyostelium antigens", "Drosophila antibodies (antigens)", "EMBL-Affinomics",
  "Enzymes", "Extracellular matrix proteins", "GFP", "Human",
  "Microbe antibodies", "Muscular dystrophy", "Neurodevelopment", "Nucleus",
  "Protein Capture Reagents", "Protein tags", "Skeletal muscle", "Stem cell",
  "Transcription factors", "Xenopus", "COVID-19", "Host-virus interaction",
  "Inflammation", "Innate Immune Response", "Lysosomes & Endosomes",
  "T-cell activation & acquired immunity", "Cytokine storm", "Interferon",
  "Fibrosis", "Macrophage Activation", "NeuroMab", "Neurodegeneration", "BICCN",
];
